<script setup lang="ts">

import { onMounted, ref} from "vue";
import {EModalId, type ModalEmptyComponent} from "@/domain/type/modal.type";

const contentRef = ref();
import {useModalStore} from "@/stores/modal.store";
const modalStore = useModalStore();

interface Props {
  content?: string
}
const props = defineProps<Props>();


onMounted(() => {

  const modalParams = modalStore.getModal(EModalId.modalEmptyComponent)?.getParam() as ModalEmptyComponent;

  if (modalParams) {
    //Carrega atraves de um modal
    if (modalParams.content) {
      contentRef.value = modalParams.content;
    }
  } else {
    //Carrega atraves de PROPS
    if (props.content) {
      contentRef.value = props.content;
    }
  }
  const modal = modalStore.getModal(EModalId.modalEmptyComponent);
  modal?.setParam({content:  contentRef.value});

});

</script>

<template>

  <div v-html="contentRef" style="white-space: break-spaces;"></div>

</template>

<style scoped>

</style>